import { render } from "./AppStage.vue?vue&type=template&id=9cae99f6&scoped=true"
import script from "./AppStage.vue?vue&type=script&lang=js"
export * from "./AppStage.vue?vue&type=script&lang=js"

import "./AppStage.vue?vue&type=style&index=0&id=9cae99f6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cae99f6"]])

export default __exports__